<template>
  <b-dialog :name="'logout-timer'">
    <template slot="header">
      <span
        >Сеанс будет окончен через {{ this.minutesToLogout }}
        {{ declOfNum(this.minutesToLogout, ['минуту', 'минуты', 'минут']) }}</span
      >
    </template>
    <template slot="content">
      <div class="uk-flex uk-flex-center content-action">
        <b-button name="Продлить сеанс" color="Red" :disabled="disabled" @click="updateSession" />
      </div>
    </template>
  </b-dialog>
</template>

<script>
import {showSuccess} from '@/common/utils/notification'

import {mapActions, mapState} from 'vuex'

export default {
  name: 'autoLogout',
  data: () => ({
    timeout: 1,
    warningTimeOffset: 5,
    timerId: null,
    timerToLogout: null,
    minutesToLogout: null,
    disabled: false,
    isShow: false
  }),
  mounted() {
    this.destroyTimer()
    this.logoutTimer()
  },
  methods: {
    ...mapActions({
      check: 'auth/CHECK'
    }),
    logoutTimer() {
      if (!this.timerId && this.user)
        this.timerId = setInterval(() => {
          if (this.user) {
            let now = new Date().getTime()
            let expiredTime = new Date(this.user.expired).getTime()
            this.timerToLogout = expiredTime - now
            let warningNotificationTime = expiredTime - this.toMilliseconds(this.warningTimeOffset)
            this.minutesToLogout = Math.floor((this.timerToLogout / 1000 / 60) << 0) + 1

            if (this.isShow === false && now >= warningNotificationTime) {
              this.warningNotification()
            }

            if (now >= expiredTime) {
              this.endSession()
            }
          }
        }, this.toMilliseconds(this.timeout))
    },
    updateSession() {
      this.disabled = true
      this.check().then(() => {
        this.isShow = false
        this.disabled = false
        this.$modal.hide('logout-timer')
      })
    },
    warningNotification() {
      this.$modal.show('logout-timer')
      this.isShow = true
    },
    logoutNotification() {
      showSuccess('Сеанс окончен')
    },
    endSession() {
      // this.$modal.hideAll()
      this.$modal.hide('logout-timer')
      this.isShow = false
      this.destroyTimer()
      this.$router.push('/login')
      this.logoutNotification()
    },
    destroyTimer() {
      if (this.timerId) {
        clearInterval(this.timerId)
      }
      this.clearData()
    },
    clearData() {
      this.timerId = null
      this.timerToLogout = null
      this.minutesToLogout = null
      this.disabled = false
      this.isShow = false
    },
    declOfNum(number, words) {
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? number % 10 : 5]
      ]
    },
    toMilliseconds(time) {
      return time * 60 * 1000
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  watch: {
    'user.expired'() {
      if (this.user && this.user.expired && this.timerId === null) {
        this.logoutTimer()
      }
      if (!this.user) {
        this.destroyTimer()
      }
    }
  }
}
</script>
